// ----------------------------------------------------------------------------
// Section: Site Header
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/menu/menu';
import 'snippets/header-menu/header-menu';
import 'snippets/mini-cart/mini-cart'; // TODO: include mini cart here for now.
import 'snippets/search-form/search';
// Predictive Search removed in favor of Rebuy Search
// import 'snippets/predictive-search/predictive-search';
import 'snippets/icon/icon';

// Styles
import './_header.scss';

// Optional Features
import './header--sticky';


// -------------------------------------
// Variables
// -------------------------------------

// Selectors
const HEADER_SELECTOR       = '.header';
const HAMBURGER_CLASS       = 'header__link--menu';
const HAMBURGER_SELECTOR    = '.header__link--menu';
const MENU_WRAPPER_SELECTOR = '.header__nav-wrapper';
const MENU_ITEM_SELECTOR    = '.header-menu__item--dropdown';
const MENU_BUTTON_SELECTOR  = '.header-menu__button';

// Classes
const OPEN_CLASS      = 'js--is-open';
const NO_SCROLL_CLASS = 'noscroll';


// -------------------------------------
// Helper functions
// -------------------------------------

function isSafari() {
    const userAgent = navigator.userAgent.toLowerCase();
    return (
        userAgent.includes('safari') &&
        !userAgent.includes('chrome') &&
        !userAgent.includes('firefox') &&
        !(userAgent.includes('android') || userAgent.includes('iphone') || userAgent.includes('ipad'))
    );
}

// Open the menu
function openMenu(menu) {
    menu.$body.classList.add(NO_SCROLL_CLASS);
    menu.$header.classList.add(OPEN_CLASS);
    menu.$hamburger.classList.add(OPEN_CLASS);
    menu.$hamburger.setAttribute('aria-expanded', 'true');
}

// Close the menu
function closeMenu(menu) {
    menu.$body.classList.remove(NO_SCROLL_CLASS);
    menu.$header.classList.remove(OPEN_CLASS);
    menu.$hamburger.classList.remove(OPEN_CLASS);
    menu.$hamburger.setAttribute('aria-expanded', 'false');
    removeClassFromElements(menu.$items, OPEN_CLASS);
    setAttributeForElements(menu.$buttons, 'aria-expanded', 'false');
}

// Remove a given class from a list of elements
function removeClassFromElements(elems, className) {
    elems.forEach(function(elem) {
        elem.classList.remove(className);
    });
}

// Set the value of a given attribute for a list of elements
function setAttributeForElements(elems, attribute, value) {
    elems.forEach(function(elem) {
        elem.setAttribute(attribute, value);
    });
}


// -------------------------------------
// Hooks
// -------------------------------------

document.addEventListener('DOMContentLoaded', function() {
    if (isSafari()) {
        document.body.classList.add('safari');
    }

    const menu = {
        $body     : document.querySelector('body'),
        $header   : document.querySelector(HEADER_SELECTOR),
        $hamburger: document.querySelector(HAMBURGER_SELECTOR),
        $items    : document.querySelectorAll(MENU_ITEM_SELECTOR),
        $buttons  : document.querySelectorAll(MENU_BUTTON_SELECTOR)
    };

    // Toggle the mobile menu when the hamburger is clicked
    // Otherwise, close the menu if clicked outside of it
    menu.$body.addEventListener('click', function(event) {
        const $this = event.target;

        let hamburgerClick = false;
        let hamburger      = null;

        if ($this.classList.contains(HAMBURGER_CLASS)) {
            hamburgerClick = true;
            hamburger = $this;
        } else {
            const closestHamburger = $this.closest(HAMBURGER_SELECTOR);

            if (closestHamburger !== null) {
                hamburgerClick = true;
                hamburger = closestHamburger;
            }
        }

        if (hamburgerClick) {
            event.preventDefault();

            if (hamburger.classList.contains(OPEN_CLASS)) {
                closeMenu(menu);
            } else {
                openMenu(menu);
            }
        } else if ($this.closest(MENU_WRAPPER_SELECTOR) === null) {
            closeMenu(menu);
        }
    });
});

// Sync content between elements when one element changes
const syncCartNumbers = (sourceSelector, targetSelector) => {
    const sourceElement = document.querySelector(sourceSelector);
    const targetElement = document.querySelector(targetSelector);

    if (sourceElement && targetElement) {
        document.addEventListener('rebuy:cart.change', (event) => { // Listen for cart changes

            fetch('/cart.js')
                .then(response => response.json())
                .then(data => {
                    console.log('cart data:', data);
                    sourceElement.innerHTML = data.item_count;
                    targetElement.innerHTML = data.item_count;
                })
                .catch(error => console.error('Error fetching cart data:', error));

        });
    }
};

// Example usage
syncCartNumbers('#cart__item-count-mobile', '#cart__item-count-desktop');
